import { useGameConfig } from '#GameFrontend/contexts/GameConfigContext';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const getSeasonIcon = (month: number) => {
	if (month >= 3 && month <= 5) {
		return <div className="sprite-48 spring drop-shadow-glow"></div>;
	} else if (month >= 6 && month <= 8) {
		return <div className="sprite-48 summer drop-shadow-glow"></div>;
	} else if (month >= 9 && month <= 11) {
		return <div className="sprite-48 autumn drop-shadow-glow"></div>;
	} else {
		return <div className="sprite-48 winter"></div>;
	}
};

interface BaseGameInformationProps {
	showBackground?: boolean;
}

export default function BaseGameInformation({ showBackground = true }: BaseGameInformationProps) {
	const [currentTime, setCurrentTime] = useState(moment().format('HH:mm'));
	const { t } = useTranslation();
	const { config, isLoading } = useGameConfig();

	useEffect(() => {}, []);

	// Get translations and their first letters
	const monthText = t('date.month');
	const yearText = t('date.year');
	const monthFirstLetter = monthText.charAt(0);
	const yearFirstLetter = yearText.charAt(0);

	return (
		<div className="flex flex-col items-start gap-1 lg:min-w-36">
			<div className={`flex flex-grow w-full h-8 justify-center items-center`}>
				<div className="flex items-center gap-2 z-20">{getSeasonIcon(config?.getGameMonths() ?? 0)}</div>
				<div
					className={`flex flex-grow w-full h-8 ${showBackground ? 'wood-dark' : ''} rounded-l-lg overflow-visible drop-shadow-lg justify-center items-center p-3 pl-5 pr-2 -ml-6`}
				>
					<div className="text-xs md:text-sm font-normal text-white flex flex-col lg:flex-row lg:gap-4 justify-end lg:items-end">
						<span className="font-normal">
							<span className="md:hidden">{monthFirstLetter}</span>
							<span className="hidden md:inline">{monthText}</span> {config?.getGameMonths() ?? 0}
						</span>
						<span className="font-normal">
							<span className="md:hidden">{yearFirstLetter}</span>
							<span className="hidden md:inline">{yearText}</span> {config?.getGameYears() ?? 0}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}
